// extracted by mini-css-extract-plugin
module.exports = {"inner":"BgListItem_inner_16jp2"};